angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('logout', {
    url: '/logout',
    views: {
      '@': {
        template: require('./logout-route.template.html')
      }
    },
    resolve: {
      $title: function() {
        return 'You’ve sucessfully logged out';
      }
    }
  });
});



// WEBPACK FOOTER //
// ./routes/logout/index.js